<template>
  <div class="navWrapper">
    
    <div id="menu" :class="{ active: isActive }">
     
      <el-menu mode="horizontal" @select="handleSelect" :router="true" id="menu">
           <section id="logo-nav"> <logo style="margin-top: -15px"></logo> </section>
        <el-submenu index="2" id="items-links" class="menu-perfil">
          <template slot="title" >
            <div id="">
              <img id="img" src="@/assets/images/user.png" alt="">
            </div>
          </template>
          <el-menu-item id="items-popup" index="1" @click="perfil()">Perfil</el-menu-item>
          <el-menu-item id="items-popup" index="/">Cerrar Sesión</el-menu-item>        
        </el-submenu>
       
        <p id="name" :style="isActive ? 'display:none' : ''">
          Bienvenido: {{ this.$session.get('name')}} {{ this.$session.get('lastname')}} | {{ this.$session.get('position')}}
        </p>
        
        <el-menu-item style="margin-top:30px" id="items-links" class="hidden" index='/' @click="select()">
         <p style="font-size: 10px; margin-bottom:10px;"> Bienvenido: {{ this.$session.get('name')}} {{ this.$session.get('lastname')}} | {{ this.$session.get('position')}} </p>
        </el-menu-item>
        <el-menu-item id="items-links" class="hidden" index='/' @click="perfil()">
          Perfil
        </el-menu-item>
        <el-menu-item id="items-links" class="hidden" index="/" :route="{ name: 'Dashboard' }" @click="select()" v-if="this.$session.get('isSuperAdmin')">
          Index
        </el-menu-item>
        <el-menu-item id="items-links" class="hidden" index="/" :route="{ name: 'adminDashboard' }" @click="select()" v-else-if="this.$session.get('isAdmin') == 'yes'" >
          Index
        </el-menu-item>
        <el-menu-item id="items-links" class="hidden" index="/" :route="{ name: 'wellcome' }" @click="select()" v-else>
          Index
        </el-menu-item>
        <el-menu-item id="items-links" class="hidden" index="/" :route="{ name: 'myCourses' }" @click="select()"
        v-if="!this.$session.get('isSuperAdmin') && this.$session.get('isAdmin') == 'no'">
          Mis cursos
        </el-menu-item>
        <el-menu-item id="items-links" class="hidden" index="/" :route="{ name: 'certificates' }" @click="select()"
        v-if="!this.$session.get('isSuperAdmin') && this.$session.get('isAdmin') == 'no'">
          Certificados
        </el-menu-item> 
        <el-menu-item id="items-links" class="hidden" index="/" :route="{ name: 'studyPlan' }" @click="select()"
        v-if="!this.$session.get('isSuperAdmin') && this.$session.get('isAdmin') == 'no'">
          Plan de Estudios
        </el-menu-item> 
        <el-menu-item id="items-links" class="hidden" index="/" :route="{ name: 'ranking' }" @click="select()">
          Ranking
        </el-menu-item> 
        <el-menu-item id="items-links" class="hidden" index="/" :route="{ name: 'AddCourse' }" @click="select()"
        v-if="this.$session.get('isSuperAdmin') || this.$session.get('isAdmin') == 'yes'">
          Crear Curso
        </el-menu-item> 
        <el-menu-item id="items-links" class="hidden" index="/" :route="{ name: 'AdminHome' }" @click="select()"
        v-if="this.$session.get('isSuperAdmin') || this.$session.get('isAdmin') == 'yes'">
          Administrar Curso
        </el-menu-item>  
        <el-menu-item id="items-links" class="hidden" index="/" :route="{ name: 'AdminHome' }" @click="perfil()"
        v-if="this.$session.get('isSuperAdmin') || this.$session.get('isAdmin') == 'yes'">
          Crear Usuarios
        </el-menu-item>  
        <el-menu-item id="items-links" class="hidden" index="/" :route="{ name: 'matriz' }" @click="select()"
        v-if="this.$session.get('isSuperAdmin') || this.$session.get('isAdmin') == 'yes'">
          Matriz de Competencias
        </el-menu-item>  
        <el-menu-item id="items-links" class="hidden" index="/" :route="{ name: 'login' }">
          Cerrar Sesión
        </el-menu-item>    
      </el-menu>
      
    </div>
    
    <div id="toggle" @click="select()">
      <div class="span" id="top" :class="{ active: isActive }"></div>
      <div class="span" id="middle" :class="{ active: isActive }"></div>
      <div class="span" id="bottom" :class="{ active: isActive }"></div>
    </div>
  </div>
</template>

<script>
import logo from '@/components/logo'
import { userAPIRoot } from '@/config/redirect.config'
export default {
  components: {
    logo
  },

  data() {
    return {
      activeIndex: '/hello',
      isActive: false,
      show: false
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      
    },
    select: function() {
      this.isActive = !this.isActive;
      if(this.isActive){
        document.getElementById('toggle').style.marginTop = "-55px";
        document.getElementById('title').style.marginTop = '10px';
        document.getElementById('name').style.marginLeft = '-400px';
        document.getElementById('name').style.display = "none";
       
      }else{
        document.getElementById('toggle').style.marginTop = "0px";
        document.getElementById('title').style.marginTop = '10px';
        document.getElementById('name').style.marginLeft = '0px';
        document.getElementById('name').style.display = 'none';
        
      }
    },
    perfil(){
      location.href = userAPIRoot+'/login?token='+this.$cookie.get('token');
    },
    Inicio() {
      this.isActive = !this.isActive;
      if(this.isActive){
        document.getElementById('toggle').style.marginTop = "-55px";
        document.getElementById('title').style.marginTop = '10px';
        document.getElementById('img-logo-course').style.marginLeft = '-400px';
       
      }else{
        document.getElementById('toggle').style.marginTop = "0px";
        document.getElementById('title').style.marginTop = '10px';
        document.getElementById('img-logo-course').style.marginLeft = '0px';
        
      }
      // console.log(this.selected)
      if(this.$session.get('isSuperAdmin')){
          this.$router.push({ name: 'Dashboard'})
      }else if(this.$session.get('isAdmin') == 'yes'){

          this.$router.push({ name: 'adminDashboard'})
      }else {
          this.$router.push({ name: 'wellcome'})
      }
    },
  },
  mounted(){
    if(!this.$session.get('userId')){
        this.$router.push({ name: "login" })
      }
  }
}
</script>




// WEBPACK FOOTER //
// src/containers/layouts/components/navbar/index.vue